import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Partner} from "../../../../../classes/partner";

@Component({
    selector: 'kan-partner-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanPartnerList {
    @Input() public partners: Partner[];
    @Input() public searchText: string;
    @Input() public loading: boolean = false;
    @Output() public refresh: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/partner/list/component.ts